// Wholesale minimum order enforcement - Client side only
// Note: This is bypassable and should be supplemented with server-side validation

(function() {
  const WHOLESALE_MINIMUM = 100.00; // $100 minimum

  // Check if current customer is wholesale
  function isWholesaleCustomer() {
    const customerMeta = document.querySelector('meta[name="customer-tags"]');
    if (!customerMeta) return false;

    const tags = customerMeta.content.split(',').map(tag => tag.trim());
    return tags.includes('wholesale');
  }

  // Get cart total by reading the displayed total on the page
  function getCartTotalFromDOM() {
    // Look for the cart total display element
    const totalElement = document.querySelector('.totals__total-value');
    if (!totalElement) return 0;

    // Extract the numeric value from the displayed text (e.g., "$125.00 USD" -> 125.00)
    const totalText = totalElement.textContent.trim();
    const numericValue = parseFloat(totalText.replace(/[^0-9.]/g, ''));

    return isNaN(numericValue) ? 0 : numericValue;
  }

  // Update checkout button state based on current cart total
  function updateEnforcement() {
    if (!isWholesaleCustomer()) return;

    const cartTotal = getCartTotalFromDOM();
    const checkoutButton = document.querySelector('button[name="checkout"]#checkout');
    const warningMessage = document.querySelector('p[style*="color: red"]');

    if (!checkoutButton) return;

    if (cartTotal >= WHOLESALE_MINIMUM) {
      // Enable checkout
      checkoutButton.style.pointerEvents = 'auto';
      checkoutButton.style.opacity = '1';
      checkoutButton.disabled = false;

      // Hide warning message
      if (warningMessage && warningMessage.textContent.includes('Wholesale minimum')) {
        warningMessage.style.display = 'none';
      }
    } else {
      // Disable checkout
      checkoutButton.style.pointerEvents = 'none';
      checkoutButton.style.opacity = '0.5';
      checkoutButton.disabled = true;

      // Show warning message
      if (warningMessage && warningMessage.textContent.includes('Wholesale minimum')) {
        warningMessage.style.display = 'block';
      }
    }
  }

  // Intercept checkout attempts
  function interceptCheckout(event) {
    if (!isWholesaleCustomer()) return;

    const cartTotal = getCartTotalFromDOM();

    if (cartTotal < WHOLESALE_MINIMUM) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      alert('Wholesale minimum order is $100. Please add more items to your cart.');
      return false;
    }
  }

  // Initialize enforcement
  function init() {
    if (!isWholesaleCustomer()) return;

    // Hide dynamic checkout buttons on product pages
    const dynamicCheckoutButtons = document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]');
    dynamicCheckoutButtons.forEach(button => {
      button.style.display = 'none';
    });

    // Update enforcement state
    updateEnforcement();

    // Intercept form submission
    const cartForm = document.querySelector('form[action="/cart"]');
    if (cartForm) {
      cartForm.addEventListener('submit', interceptCheckout, true);
    }

    // Intercept button clicks
    const checkoutButton = document.querySelector('button[name="checkout"]#checkout');
    if (checkoutButton) {
      checkoutButton.addEventListener('click', interceptCheckout, true);
    }
  }

  // Watch for changes to the cart total element
  function observeCartTotal() {
    const totalElement = document.querySelector('.totals__total-value');
    if (!totalElement) {
      // Try again in a moment
      setTimeout(observeCartTotal, 500);
      return;
    }

    const observer = new MutationObserver(function(mutations) {
      // Cart total changed, update enforcement
      updateEnforcement();
    });

    observer.observe(totalElement, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      init();
      observeCartTotal();
    });
  } else {
    init();
    observeCartTotal();
  }

  // Also watch the entire cart footer for replacements
  function observeCartFooter() {
    const cartFooter = document.getElementById('main-cart-footer');
    if (!cartFooter) return;

    const observer = new MutationObserver(function(mutations) {
      // Cart footer was updated, re-initialize
      updateEnforcement();
      // Re-attach event listeners to new elements
      const checkoutButton = document.querySelector('button[name="checkout"]#checkout');
      if (checkoutButton) {
        checkoutButton.addEventListener('click', interceptCheckout, true);
      }
    });

    observer.observe(cartFooter, {
      childList: true,
      subtree: true
    });
  }

  setTimeout(observeCartFooter, 500);

})();
